import React from "react";
import BookingNavigation from "./BookingNavigation";
import styles from "../../styles/public/footer.module.css";

const Footer = ({ showNavigation, onClick, handleContinue, disabled, continueText, showContinueButton }) => {
  return (
    <footer className={`${styles["footer"]} bg-dark`}>
      {showNavigation && (
        <BookingNavigation
          onClick={onClick}
          handleContinue={handleContinue}
          disabled={disabled}
          continueText={continueText}
          showContinueButton={showContinueButton}
        />
      )}
      <div className={`${styles["footer-content"]} text-center text-white py-3`}>
        Powered by VioptiQ LLC<br/>
        &copy; {new Date().getFullYear()} All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;